export default "__VITE_ASSET__IFiRJeap__"